import React, { useContext, useEffect, useState } from 'react'
import { Flex, Flexed, Input, Label, Selectbox } from '../../../utilities/Shared'
import EstContext from '../../../Context/EstContext'
import PaperSelect from '../../../utilities/PaperSelect'
import Sheet from './Sheet'
import { Plus, X } from 'lucide-react'
import { v4 as uuidv4 } from 'uuid';
import Collapse from '../../../utilities/Collapse'
import { changeidtopress } from '../../../utilities/Convertions'
import Synop from './Synop'
import { inks } from '../../../utilities/Lists'

const Form = ({item,index,option}) => {

const {info,setInfo,paperlist,inklist,getplates,platecost} = useContext(EstContext)

console.log(item)

  const [bleed, setBleed] =  useState(.125)

    const [tail, setTail] =  useState(.125)
    const [colorbar, setColorbar] =  useState(.250)
    const [colorbarbuff, setColorbarbuff] =  useState(.125)
    const [gripper, setGripper] =  useState(.4375) 

     const [sheetcolorbarbuff, setSheetcolorbarbuff] =  useState(colorbarbuff)
     const [totalsheetwidth ,setTotalsheetwidth] =  useState(0)
     const [totalsheetlength ,setTotalsheetlength] =  useState(0)
     const [totalpiece ,setTotalpiece] =  useState({})
     const [neededsheets ,setNeededsheets] =  useState(0)

     const [newmr ,setNewmr] =  useState(0)
     const [newbackmr ,setNewbackmr] =  useState(0)
     const [newfrontink ,setNewfrontink] =  useState(0)
     const [newbackink ,setNewbackink] =  useState(0)
     const [addlsheets ,setAddlsheets] =  useState(0)
     const [totalsheets ,setTotalsheets] =  useState(0)
     const [paperbase ,setPaperbase] =  useState(0)
     const [papercount ,setPapercount] =  useState(0)
     // digital margin 0.375
  const [layout, setLayout] = useState(() => {
    // const savedLayout = localStorage.getItem('sheetLayout');
    // return savedLayout ? JSON.parse(savedLayout) : [];
    return []
  });

  useEffect(() => {
    setTotalsheets(parseInt(neededsheets) + parseInt(item?.addlsheets) || 0)
    changeinformation('needed',parseInt(neededsheets) || 0 )
    changeinformation('totalsheets',parseInt(neededsheets) + (parseInt(item?.addlsheets)|| 0) + (parseInt(item?.mr)|| 0))
  
  },[neededsheets,item?.addlsheets])

             useEffect(() => {
                 let aa= parseInt(item.parentL) *  parseInt(item.parentW)
                 let bb= parseInt(item.pressL) *  parseInt(item?.pressW)
        let j = aa / bb
    
        const jj = {...info}
        let h = jj.options[option]
        h.forms[index].parentout = parseInt(j)
        setInfo(jj)
        getpieces()
        getinks()
        getpaper()
               },[item?.parentL,item?.parentW,item?.pressW,item?.pressL,item?.press,item?.paperid,item?.percentvalue,item?.addtlsheets,item?.needed])



const getgripper = () => {
  
}

console.log(newmr)
useEffect(() => {
    getinks()
  
    setNewmr(getinks(item?.mr,item?.frontinkpercent,item?.frontInks))
    setNewbackmr(getinks(item?.mr,item?.backinkpercent,item?.backInks))
    setNewfrontink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.frontinkpercent,item?.frontInks))
    setNewbackink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.backinkpercent,item?.backInks))
},[info])

useEffect(() => {
    getinks()
},[info])

useEffect(() => {
    getmr()
    setNewmr(getinks(item?.mr,item?.frontinkpercent,item?.frontInks))
    setNewbackmr(getinks(item?.mr,item?.backinkpercent,item?.backInks))
    setNewfrontink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.frontinkpercent,item?.frontInks))
    setNewbackink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.backinkpercent,item?.backInks))
},[item.press,item?.method,item?.frontInks,item?.backInks])
             
useEffect(() => {

    getpieces()
    setNewmr(getinks(item?.mr,item?.frontinkpercent,item?.frontInks))
    setNewbackmr(getinks(item?.mr,item?.backinkpercent,item?.backInks))
    setNewfrontink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.frontinkpercent,item?.frontInks))
    setNewbackink(getinks(Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)),item?.backinkpercent,item?.backInks))
},[JSON.stringify(item.versions)])


const changeinfo = (e,item) => {
    const jj = {...info}
    let h = jj.options[option]
   h.forms[index][item] = e.target.value
setInfo(jj)
}
 
const changepercent = (e,item,item2) => {
    console.log('Pams sweet ass')
    const jj = {...info}
    let h = jj.options[option]
    let newvalue = ((parseInt(e.target.value) /100) + 1)
    console.log(newvalue)
 h.forms[index][item] = newvalue
  h.forms[index][item2] = e.target.value
setInfo(jj)
}

const getpressforinks = (press) => {
    let newpress
switch(press){
case "3":
case "4":
    newpress="2"
break;
case "5":
case "6":
    newpress="1"
break;
default:
    newpress="0"
break;   
}
return newpress
}

const getinks = (quant,percent,arrayinks) => {

    console.log(quant)
let finks = arrayinks?.split(",")
let press = getpressforinks(item?.press)
let newink = {}
if(press === "2"){
 // Map color codes to full color names
 const colorMap = {
    C: 'cyan',
    M: 'magenta',
    Y: 'yellow',
    K: 'black',
    c: 'cyan',
    m: 'magenta',
    y: 'yellow',
    k: 'black'
  };
// Find matching inks for each color code
const matchedInks = finks?.map(code => {
    const color = colorMap[code];
    
    if (!color) {
        // Unmatched code: select a PMS ink with color "All" and specified press
        return inks?.find(ink =>
          ink.type === 'PMS' &&
          ink.color === 'All' &&
          ink.press === press
        ) || null;
      }

      // Matched code: select a process ink with matching color and press
      return inks.find(ink =>
        ink.color === color &&
        ink.press === press
      ) || null;
    }).filter(ink => ink !== null); // Remove null entries
console.log(item)
const newcost = 0
const spread = parseFloat(percent) / 100
const tot = (Math.ceil(parseInt(quant)) || 0) 
console.log(tot)
const size = ((parseFloat(item?.pressL) * parseInt(item?.pressW)) * tot * spread).toFixed()
console.log(size)

let h = 0
let hh = 0
let hhh = `${item?.pressL} x ${item?.pressW} * ${tot} * ${spread} =  ${size}<br />`
console.log(matchedInks)
    matchedInks?.map(inkk => {  
         console.log(inkk) 
        console.log(inkk.specific)
h += parseFloat(size) / parseFloat(inkk.specific)
console.log(h)
hh += ((parseFloat(size) / parseFloat(inkk.specific)).toFixed(3) * parseFloat(inkk.price))
 console.log(hh) 
 hhh += `${inkk.color} - ${size} / ${inkk.specific} = ${(size / inkk.specific).toFixed(3)} * ${inkk.price} = $${((size / inkk.specific).toFixed(3) * parseFloat(inkk.price)).toFixed(2)}<br />`    
    })
hhh += ``  
    newink = {lbs:h.toFixed(3),cost:hh.toFixed(2),desc:hhh}
   }
   return newink
};




const getpaper = () => {

    let tot = Math.ceil(Math.ceil((parseInt(item?.needed)|| 0) * (parseFloat(item?.percentover))+ (parseInt(item?.addtlsheets) || 0) + (parseInt(item?.mr) || 0)) / parseInt(item?.parentout))
    console.log(tot)

  changeinformation('sheetstoorder',tot)
  // setPaperbase(getpapercost(parseInt(item?.mr)))
  let a = parseFloat(item?.parentL) * parseFloat(item?.parentW) * parseInt(item?.paperweight) * 2
  a /= parseInt(item?.paperdivide)

  changeinformation('papermweight',Math.ceil(a))
  let paperbasepounds = Math.ceil((a * tot) / 1000)
  changeinformation('paperbasepounds',paperbasepounds)
  let paperleft = (Math.ceil(parseInt(item?.needed) * 1.05))
  let paperpounds = Math.ceil((a * paperleft) / 1000)
  changeinformation('paperpounds',paperpounds)

}


const gettotalpapercost = (form) => {

   // Math.ceil((item.needed + parseInt(item.addtlsheets))* item.percentover)) + parseInt(item.mr)) || 0
    let r = 0
   form.map(item => {

   })
return r
}

const getformpapercost = (item) => {
  // Validate input

  // Calculate total cost


    const mr = Number(item.mr) || 0;
    const addtlSheets = Number(item.addtlsheets) || 0;
    const needed = Number(item.needed) || 0;
    const percentOver = Number(item.percentover) || 0;
    const paperPerThou = Number(item.paperperthou) || 0;

    // Calculate cost for this item
    const sheets = Math.ceil(mr + addtlSheets + needed * percentOver);
    const cost = (sheets * paperPerThou) / 1000;


  // Return rounded to 2 decimal places
  return Number(cost.toFixed(2));
};


const setinkcost = (inks) => {
    let tot =0
    let pounds = 0
inks.map(ink => {
tot += parseFloat(ink.cost)
pounds += parseFloat(ink.lbs)
})

}

const changeinformation = (item,value) => {
    const jj = {...info}
    let h = jj.options[option]
   h.forms[index][item] = value
setInfo(jj)
}


const getmr = () => {

switch(item?.press){
case '5':
case '6':
    changeinformation('mr',4000)
break;
case '3':
case '4':
    switch(item.method){
case "Work & Turn":
case "Work & Tumble":
case "Perfect":
    let a = item?.frontInks.split(',')
    changeinformation('mr',parseInt(a.length) * 100 + 100)
    break;
    case "Sheetwise":
      let c = item?.frontInks.split(',')
 let  b = item?.backInks.split(',')
 changeinformation('mr',(parseInt(c.length) + parseInt(b.length)) * 100)

  break;
  case "One-Sided":
 let e = item?.frontInks.split(',')
 changeinformation('mr',parseInt(e.length) * 100)
   break;
    default:
        changeinformation('mr',0)
    break;
    }   
break;
case '7':
case '8':
case '9':
case '10':
    changeinformation('mr',5)
break;
default:
    changeinformation('mr',0)
    break;
}


}


const changever = (e,verindex,field) => {
    const jj = {...info}
    let h = jj.options[option]
   h.forms[index].versions[verindex][field] = e.target.value
   h.forms[index].versions[verindex].itemid=uuidv4()
   h.forms[index].versions[verindex].height =  h.forms[index].versions[verindex].length
setInfo(jj)

}

 


    const getpressfromid = (press) => {
let h
switch(press){
case "3":
case "4":
  h = 2
  break;

}
return h
    }


const whatkindofstoack = (id) => {
    let y = paperlist.filter(filt => filt.stockid === id)
    return y[0]?.kind || (<div style={{fontSize:"inherit",color:"rgb(255,0,0,.7)",fontWeight:"bold"}}>Paper Type Not Selected</div>)
    }

const getpieces = () => {
let ver = item.versions
let hh = []
ver.map(version => {
if(parseInt(version.up) <= 0){

    let testAwidth = Math.floor(parseFloat(item.pressW) / (parseFloat(version.width) + (parseFloat(bleed) * 2))) 
    let testAlength = Math.floor(parseFloat(item.pressL) / (parseFloat(version.length) + (parseFloat(bleed) * 2)))
    let testA = testAlength * testAwidth
    let testBwidth = Math.floor(parseFloat(item.pressL) / (parseFloat(version.width) + (parseFloat(bleed) * 2))) 
    let testBlength = Math.floor(parseFloat(item.pressW) / (parseFloat(version.length) + (parseFloat(bleed) * 2))) 
    let testB = testBlength * testBwidth


    if(testB > testA){
        hh.push({itemid:uuidv4(),quantity:item.quantity,up:testB,length:version.width,width:version.length,name:version.name,test:"Test B"})  
    }else{ 
        hh.push({itemid:uuidv4(),quantity:item.quantity,up:testA,width:version.width,length:version.length,name:version.name,test:"Test A"})
    }
 
    const jj = {...info}
    let h = jj.options[option]
   h.forms[index].versions= hh
setInfo(jj)
}
})
}



const addversion = () => {
    
     const deepCopyObj = JSON.parse(JSON.stringify(info.options[option].forms[0].versions[0]));
  
     deepCopyObj.itemid = uuidv4()
     deepCopyObj.name =""   //`Version ${info.options[option].forms[index]?.versions?.length + 1}`
 
     const jj = {...info}
     let h = [...jj.options[option].forms[index].versions,deepCopyObj]
    jj.options[option].forms[index].versions = h 
  
      setInfo(jj) 
}


const removeversion = (itemid) => {

let hh = info.options[option].forms[index].versions.filter(filt => filt.itemid !== itemid )

const jj = {...info}
jj.options[option].forms[index].versions = hh 
 setInfo(jj) 
}

useEffect(() => {
    getsheetsizes()
    getinks()
},[item.pressL,item.pressW,item?.edges])

const getsheetsizes = () => {
  let l = (info.options[option].forms[index].pressL - tail - colorbar - colorbarbuff - gripper)
   let w  =(info.options[option].forms[index].pressW - item?.edges - item?.edges)


setTotalsheetwidth(w)

setTotalsheetlength(l)

}

const plates = (item ) => {
    let a = 0

    switch(item.method){
case 'Sheetwise':
case 'Perfect':
    switch(item.press){
case '3':
case '4':
case '5':
case '6':
   let f = item.frontInks.split(',').length
    let g = item.backInks.split(',').length
    a = f+g
    break;
     case 'Work & Turn':
    case 'Work & Tumble':
    case 'One-Sided':
    switch(item.press){
case '3':
case '4':
case '5':
case '6':
    a = item.frontInks.split(',').length
    }
  break;   
default:
    a = 0
    break;
    }
}
console.log(item)
return a
}



console.log( info)


  return (
    <>
    <Flexed>

<Flex flex="1.5">
<Flexed marginTop="10px">
<Flex flex="2"><Label>Name</Label><br /><Input value={item.name} onChange={e => changeinfo(e,'name')}/></Flex>   
<Flex flex="2"><Label>Press</Label><br />
<Selectbox value={item.press} onChange={e => changeinfo(e,'press')}>
<option value="0">Select Press</option>
<option value="8">Ricoh Color</option>
<option value="4">GL440- 4 Color</option>
<option value="7">Ricoh B&W</option>
<option value="9">Colormax - Envelope</option>
<option value="5">M110  - Folding</option>
<option value="10">Ricoh Oversize</option>
<option value="6">M110  - Sheeter</option>
<option value="3">GL540- 5 Color</option>
</Selectbox></Flex>   
<Flex flex="2"><Label>Method</Label><br />
<Selectbox value={item.method} onChange={e => changeinfo(e,'method')}>
    <option value="">Select Method</option>
    <option value="Sheetwise">Sheetwise</option>
    <option value="Work & Turn">Work & Turn</option>
    <option value="One-Sided" >One-Sided</option>
    <option value="Perfect">Perfect</option>
    <option value="Work & Tumble">Work & Tumble</option>
</Selectbox>
</Flex>  
<Flex><Label>Pages</Label><br /><Input value={item.pages} /></Flex>   
<Flex></Flex>  
</Flexed>

<Flexed marginTop="15px">
<Flex flex="2"><Label>Front Ink's</Label><br /><Input value={item.frontInks} onChange={e => changeinfo(e,'frontInks')}/></Flex>   
<Flex><Label>Front %</Label><br /><Input value={item.frontinkpercent} onChange={e => changeinfo(e,'frontinkpercent')}/></Flex>  
<Flex><Label>Front Coat</Label><br />
<Selectbox  value={item.faq} onChange={e => changeinfo(e,'faq')}>
<option value="">Select Coating 1</option>
<option value="None">None</option>
   <optgroup label="Flood">
		<option value="FGAQ">F Gloss AQ</option>
		<option value="FDAQ">F Dull AQ</option>
		<option value="FSTAQ">F Soft Touch AQ</option>
		<option value="FPAQ">F Pearl AQ</option>
		<option value="FSAQ">F Satin AQ</option>
		<option value="FGUV">F Gloss UV</option>
		<option value="FDUV">F Dull UV</option>
<option value="FCC">F Clear Coat</option>
   </optgroup>
    <optgroup label="Spot">
		<option value="SGAQ">S Gloss AQ</option>
		<option value="SDAQ">S Dull AQ</option>
		<option value="SSTAQ">S Soft Touch AQ</option>
		<option value="SPAQ">S Pearl AQ</option>
		<option value="SSAQ">S Satin AQ</option>
		<option value="SGUV">S Gloss UV</option>
		<option value="SDUV">S Dull UV</option>
<option value="SCC">S Clear Coat</option>
   </optgroup>
    <optgroup label="Strike Thru">
		<option value="STGAQ">ST Gloss AQ</option>
		<option value="STDAQ">ST Dull AQ</option>
		<option value="STSTAQ">ST Soft Touch AQ</option>
		<option value="STPAQ">ST Pearl AQ</option>
		<option value="STSAQ">ST Satin AQ</option>
		<option value="STGUV">ST Gloss UV</option>
		<option value="STDUV">ST Dull UV</option>
<option value="STCC">ST Clear Coat</option>
   </optgroup> 
</Selectbox>
</Flex>   
</Flexed> 

<Flexed marginTop="15px">
<Flex flex="2"><Label>Back Ink's</Label><br /><Input value={item.backInks} onChange={e => changeinfo(e,'backInks')}/></Flex>   
<Flex><Label>Back %</Label><br /><Input value={item.backinkpercent} onChange={e => changeinfo(e,'backinkpercent')}/></Flex>  
<Flex><Label>Back Coat</Label><br />
<Selectbox value={item.baq} onChange={e => changeinfo(e,'baq')}>
<option value="">Select Coating 1</option>
<option value="None">None</option>
   <optgroup label="Flood">
		<option value="FGAQ">F Gloss AQ</option>
		<option value="FDAQ">F Dull AQ</option>
		<option value="FSTAQ">F Soft Touch AQ</option>
		<option value="FPAQ">F Pearl AQ</option>
		<option value="FSAQ">F Satin AQ</option>
		<option value="FGUV">F Gloss UV</option>
		<option value="FDUV">F Dull UV</option>
<option value="FCC">F Clear Coat</option>
   </optgroup>
    <optgroup label="Spot">
		<option value="SGAQ">S Gloss AQ</option>
		<option value="SDAQ">S Dull AQ</option>
		<option value="SSTAQ">S Soft Touch AQ</option>
		<option value="SPAQ">S Pearl AQ</option>
		<option value="SSAQ">S Satin AQ</option>
		<option value="SGUV">S Gloss UV</option>
		<option value="SDUV">S Dull UV</option>
<option value="SCC">S Clear Coat</option>
   </optgroup>
    <optgroup label="Strike Thru">
		<option value="STGAQ">ST Gloss AQ</option>
		<option value="STDAQ">ST Dull AQ</option>
		<option value="STSTAQ">ST Soft Touch AQ</option>
		<option value="STPAQ">ST Pearl AQ</option>
		<option value="STSAQ">ST Satin AQ</option>
		<option value="STGUV">ST Gloss UV</option>
		<option value="STDUV">ST Dull UV</option>
<option value="STCC">ST Clear Coat</option>
   </optgroup> 
</Selectbox>
</Flex>   
</Flexed>

<Flexed marginTop="15px">   
          <Flex flex=".5"  padding="3px 0px 0px 0px" onClick={e => addversion()}> <Plus color="green" size="20" strokeWidth={2}/><br />Version</Flex >
          <Flex><Label>Ver's</Label><br /><Input value={item.versions.length} width="60%" disabled/></Flex>  
          <Flex flex="2"><Label>Required </Label><br /><Input value={neededsheets === "Infinity" || neededsheets < 0 ? "" : neededsheets}  width="60%" onChange={e => setNeededsheets(e.target.value)}/></Flex>  
          <Flex flex="2"><Label>M/R</Label><br /><Input value={item?.mr}  width="60%" onChange={e => changeinfo(e,'mr')}/></Flex> 
          <Flex flex="2"><Label>% Over</Label><br /><Input value={item?.percentvalue}  width="60%" onChange={e => changepercent(e,'percentover','percentvalue')}/></Flex> 
          <Flex flex="2"><Label>Addt'l </Label><br /><Input value={item?.addtlsheets}  width="60%" onChange={e => changeinfo(e,'addtlsheets')}/></Flex> 
          <Flex flex="2"><Label>Total</Label><br /><Input value={Math.ceil((parseInt(item?.needed) || 0) * parseFloat(item.percentover) + (parseInt(item?.addtlsheets) || 0) +  parseInt(item?.mr) || 0) }  width="60%" disabled/></Flex> 
        </Flexed>
       
<Flexed >
  
    <Flex>{
   item.versions?.map((ver,verindex) => {
       return  <Flexed marginTop="15px">
<Flex><Label>Name</Label><br /><Input value={ver.name} onChange={e => changever(e,verindex,'name')}/></Flex> 
<Flex><Label>Quantity</Label><br /><Input value={ver.quantity} onChange={e => changever(e,verindex,'quantity')}/></Flex> 
<Flex><Label>Piece W</Label><br /><Input value={ver.width} onChange={e => changever(e,verindex,'width')}/><br /></Flex>  
<Flex><Label>Piece L</Label><br /><Input value={ver.length} onChange={e => changever(e,verindex,'length')}/><br /></Flex>  
<Flex><Label># Up</Label><br /><Input value={ver.up} onChange={e => changever(e,verindex,'up')}/> </Flex> 
<Flex flex=".01" display="flex" margin="25px 0px 0px 0px" color="red" onClick={e => removeversion(ver.itemid)}><X size="16"/></Flex>
</Flexed>
   })
}</Flex>
</Flexed>




<Flexed marginTop="10px">  

    <Flex flex="5"><Label>Paper</Label><br />
<PaperSelect list={paperlist} listid="paperlist" value={item.papername} index={index} option={option} />
     
</Flex>
<Flex><Label>ID</Label><br /><Input value={item.paperid}/></Flex>  
</Flexed>
<Flexed>
    <Flex>  <span style={{fontSize:"calc(1.2rem + .2vw)",color:!item?.papercategory || item?.paperstockid === "" ? "red" : "inherit"}}>{whatkindofstoack(item?.paperid)}</span></Flex>
     <Flex>Per K <Input value={item.paperperthou} onChange={e => changeinfo(e,'paperperthou')}/></Flex>
      <Flex>CWT <Input value={item.papercwt} onChange={e => changeinfo(e,'edges')}/></Flex>
</Flexed>


<Flex fontSize="calc(1.3rem + .2vw)" margin="10px 0px 0px 0px">
<Synop item={item} layout={layout} totalsheets={totalsheets} />
</Flex>







</Flex>

<Flex padding="0"  style={{position:"relative",border:"1px solid #303030",minWidth:"400px",minHeight:"280px",maxWidth:"600px",display:"flex",alignItems:"center",justifycontent:"center",flexDirection:"column"}}>
        <Sheet versions={item.versions} pieces={totalpiece} sheetcolorbarbuff={sheetcolorbarbuff} setSheetcolorbarbuff={setSheetcolorbarbuff} totalsheetwidth={totalsheetwidth} setTotalsheetwidth={setTotalsheetwidth} length={item.pressL} width={item.pressW} totalsheetlength={totalsheetlength} setTotalsheetlength={setTotalsheetlength}  tail={tail} colorbar={colorbar} colorbarbuff={colorbarbuff} edges={item?.edges} gripper={gripper} bleed={bleed} setNeededsheets={setNeededsheets} layout={layout} setLayout={setLayout} changeinfo={changeinfo}/>
        <Flexed>
            <Flex style={{fontSize:"calc(1.1rem + .2vw)",margin:"8px 0px",textAlign:"center"}}>{totalsheetlength} X {totalsheetwidth}</Flex>
        </Flexed>
        <Flexed marginTop="10px">
            <Flex><Label>Parent L</Label><br /><Input value={item.parentL} onChange={e => changeinfo(e,'parentL')}/></Flex>  
        <Flex><Label>Parent W</Label><br /><Input value={item.parentW} onChange={e => changeinfo(e,'parentW')}/></Flex>  
        <Flex><Label>Parent Out</Label><br /><Input color={item.parentout === 0 || !item.parentout ? "red" : "inherit"} fontWeight={item.parentout > 0 ? "inherit" : "bold"} value={item.parentout || 0} onChange={e => changeinfo(e,'parentout')}/></Flex> 
         </Flexed>
         <Flexed marginTop="10px">
         <Flex><Label>Press L</Label><br /><Input value={item.pressL} onChange={e => changeinfo(e,'pressL')}/></Flex>  
         <Flex><Label>Press W</Label><br /><Input value={item.pressW} onChange={e => changeinfo(e,'pressW')}/></Flex>  
         <Flex><Label>/Form X</Label><br /><Input value={item.forms} onChange={e => changeinfo(e,'forms')}/></Flex> 
         </Flexed>
      
        <Flexed marginTop="10px" >
        <Flex><Label>Bleed</Label><br /><Input value={bleed}  onChange={e => setBleed(e.target.value)}/></Flex>  
            <Flex><Label>Edges</Label><br /><Input value={item.edges} onChange={e => changeinfo(e,'edges')} /></Flex>   
            <Flex><Label>Tail</Label><br /><Input value={tail} disabled/></Flex> 
            <Flex><Label>Colorbar</Label><br /><Input type="number"  value={colorbar}  disabled/></Flex>   
 
        </Flexed>
    </Flex>

            </Flexed>


<Flexed></Flexed>


        
        

         

            <div className="hand" style={{background:"#CFCDCC",marginBottom:"8px",border:"1px solid #c0c0c0",padding:"4px 0px",color:"black",marginTop:"10px"}} >
    <Collapse  margin="0" title={<Flexed alignItems="center" fontSize="calc(1.1rem + .2vw)">
     
          <Flex >Inks - </Flex>
         
          <Flex flex="0" padding="0px 5px" whiteSpace="nowrap" >Lbs: {(parseFloat(newbackmr.lbs) + parseFloat(newmr.lbs) + parseFloat(newfrontink.lbs) + parseFloat(newbackink.lbs)||0).toFixed(3) }</Flex><Flex flex="0"  padding="0px 5px" whiteSpace="nowrap">Cost:{(parseFloat(newbackmr.cost) + parseFloat(newmr.cost) + parseFloat(newfrontink.cost) + parseFloat(newbackink.cost)||0).toFixed(2)} </Flex>
          
    </Flexed>} >
    <Flexed  fontSize="calc(1.1rem + .2vw)" fontWeight="bold" color='black'>
        <Flex flex=".5" > Quantity</Flex>
        <Flex flex="1.5"> Front Inks</Flex>
        <Flex flex="1.5"> Back  Inks</Flex> 
</Flexed>
<Flexed style={{color:"black",fontSize:"calc(1rem + .2vw)",padding:"4px 0px",lineHeight:"20px"}}>
      <Flex  flex=".5" >Base - {item?.mr}</Flex>
 <Flex flex="1.5"> <div style={{fontSize:"calc(1rem + .2vw)"}} dangerouslySetInnerHTML={{ __html:newmr.desc}} /></Flex>
  <Flex flex="1.5"> <div style={{fontSize:"calc(1rem + .2vw)"}} dangerouslySetInnerHTML={{ __html:newbackmr.desc}} /> </Flex> 
{/*      
        backs  -  {newbackink.lbs} - {newbackink.cost}<br/>
            needed sheets - {Math.ceil(((parseFloat(item?.needed) || 0) + (parseFloat(item?.addtlsheets) || 0 )) * 1.05)} <br/>
           additional -  {parseFloat(item?.addtlsheets) || 0}<br/>

        total sheets -  {Math.ceil(parseFloat(item?.needed) * 1.05) + (parseFloat(item?.mr) || 0) + (parseFloat(item?.addtlsheets) || 0)}<br />

        per K -  {((parseFloat(newfrontink.cost) + parseFloat(newbackink.cost) + parseFloat(newmr.cost) + parseFloat(newbackmr.cost)) /(Math.ceil(parseFloat(item?.needed) * 1.05) + (parseFloat(item?.mr) || 0) + (parseFloat(item?.addtlsheets) || 0)) * 1000).toFixed(2)}  */}

    </Flexed>
    <Flexed style={{color:"black",fontSize:"calc(1.2rem + .2vw)",textAlign:"right",marginTop:"5px",background:"rgb(0,0,0,.2)",padding:"5px 10px"}}>
        <Flex>
           Total LBS:&nbsp;{newmr.lbs}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quote Price:&nbsp;${newmr.cost}
        </Flex>
          <Flex>
           Total LBS:&nbsp;{newbackmr.lbs}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quote Price:&nbsp;${newbackmr.cost}
        </Flex>
    </Flexed>
    <Flexed style={{color:"black",fontSize:"calc(1rem + .2vw)",padding:"4px 0px",lineHeight:"20px",marginTop:"10px"}}>
      <Flex  flex=".5" >Sheets - {Math.ceil(item?.needed * item?.percentover).toFixed()}</Flex>
 <Flex flex="1.5"> <div style={{fontSize:"calc(1rem + .2vw)"}} dangerouslySetInnerHTML={{ __html:newfrontink.desc}} /></Flex>
  <Flex flex="1.5"> <div style={{fontSize:"calc(1rem + .2vw)"}} dangerouslySetInnerHTML={{ __html:newbackink.desc}} /> </Flex> 
    </Flexed>
       <Flexed style={{color:"black",fontSize:"calc(1.2rem + .2vw)",textAlign:"right",marginTop:"5px",background:"rgb(0,0,0,.2)",padding:"5px 10px"}}>
        <Flex >
           Total LBS:&nbsp;{newfrontink.lbs}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quote Price:&nbsp;${newfrontink.cost}
        </Flex>
          <Flex>
           Total LBS:&nbsp;{newbackink.lbs}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quote Price:&nbsp;${newbackink.cost}
        </Flex>
    </Flexed>
    </Collapse>
</div>


<div className="hand" style={{background:"#CFCDCC",marginBottom:"8px",border:"1px solid #c0c0c0",padding:"4px 0px",color:"black",marginTop:"10px"}} >
    <Collapse  margin="0" title={<Flexed alignItems="center" fontSize="calc(1.1rem + .2vw)">
          <Flex >Paper</Flex>
      
          <Flex flex="0" whiteSpace="nowrap">Cost: 0.00</Flex>
          <Flex flex="0" whiteSpace="nowrap">Total Cost: {gettotalpapercost(info.options)}</Flex>
    </Flexed>} >
  


{
    info.options.map((form,index) => {
        console.log(form)
 return <div style={{padding:'8px 0px'}}> <Flexed>
    <Flex color='black' fontWeight='bold' fontSize='calc(1.2rem + .2vw)'>Option {index + 1}</Flex></Flexed> 
   <Flexed  fontSize="calc(1.1rem + .2vw)" fontWeight="bold" color='black'>
          <Flex >Form</Flex>
          <Flex >Paper Name</Flex>
        <Flex flex=".5" >Quantity </Flex>
        <Flex flex="1.5"> Sheets</Flex>
        <Flex flex="1.5"> Rolls</Flex> 
</Flexed>


{
    form.forms?.map(item => {
        return  <><div style={{borderBottom:"1px solid grey",padding:'7px 0px'}}>
  <Flexed  color='black' fontSize="calc(1rem + .2vw)">
    <Flex >{item?.name}</Flex>
   <Flex  >{item?.papername.split('-',1)}</Flex>
        <Flex flex=".5" > {(Math.ceil((item.needed + parseInt(item.addtlsheets))* item.percentover))}</Flex>
        <Flex flex="1.5"> {(Math.ceil((item.needed + parseInt(item.addtlsheets))* item.percentover))} X {item.paperperthou}/K = {(((Math.ceil((item.needed + parseInt(item.addtlsheets))* item.percentover))) * item.paperperthou / 1000).toFixed(2)}</Flex>
        <Flex flex="1.5"> </Flex> 
</Flexed>
      <Flexed  color='black' fontSize="calc(1rem + .2vw)" >
    <Flex >Base</Flex>
   <Flex  >{item?.papername.split('-',1)}</Flex>
        <Flex flex=".5" > {item.mr}</Flex>
        <Flex flex="1.5" > {item.mr} X {item.paperperthou}/K = {(item.mr * item.paperperthou / 1000).toFixed(2)}</Flex>
        <Flex flex="1.5"> </Flex> 
</Flexed> 
      <Flexed  color='black' fontSize="calc(1rem + .2vw)" style={{borderTop:'1px dashed gray'}}>
    <Flex ></Flex>
   <Flex  ></Flex>
        <Flex flex=".5" fontWeight='bold'> {Math.ceil((Math.ceil((item.needed + parseInt(item.addtlsheets))* item.percentover)) + parseInt(item.mr)) || 0}</Flex>
        <Flex flex="1.5" textAlign='center' fontWeight='bold'>{getformpapercost(item)}</Flex>
        <Flex flex="1.5"> </Flex> 
</Flexed> 
</div>
</>
    })
}

 {/* <Flexed  color='black' fontSize="calc(1rem + .2vw)">
        <Flex flex=".5" >  - {form.sheetstoorder - form.mr} </Flex>
        <Flex flex="1.5">{form.sheetstoorder - form.mr} X {form.paperperthou}/K = {((form.sheetstoorder - form.mr) * form.paperperthou / 1000).toFixed(2)} </Flex>
        <Flex flex="1.5"> </Flex> 
</Flexed> */}
</div>
    })
}


    </Collapse>
</div>

{ parseInt(item.press) < 7 &&
<div className="hand" style={{background:"#CFCDCC",marginBottom:"8px",border:"1px solid #c0c0c0",padding:"4px 0px",color:"black",marginTop:"10px"}} >
    <Collapse  margin="0" title={<Flexed alignItems="center" fontSize="calc(1.1rem + .2vw)">
          <Flex >Plates</Flex>
      
          <Flex flex="0" whiteSpace="nowrap">Cost: 0.00</Flex>
          <Flex flex="0" whiteSpace="nowrap">Total Cost: 0</Flex>
    </Flexed>} >
  


{
    info.options.map((form,index) => {
        console.log(form)
 return <div style={{padding:'8px 0px'}}> <Flexed>
    <Flex color='black' fontWeight='bold' fontSize='calc(1.2rem + .2vw)'>Option {index + 1}</Flex></Flexed> 
   <Flexed  fontSize="calc(1.1rem + .2vw)" fontWeight="bold" color='black'>
          <Flex >Form</Flex>
          <Flex >Needed</Flex>
        <Flex flex=".5" >Extra </Flex>
        <Flex flex="1.5"> Cost</Flex>
        <Flex flex="1.5" textAlign='right'> Total</Flex> 
</Flexed>


{
    form.forms?.map(item => {
        return  <><div style={{borderBottom:"1px solid grey",padding:'7px 0px'}}>
  <Flexed  color='black' fontSize="calc(1rem + .2vw)">
    <Flex >{item?.name}</Flex>
   <Flex  >{getplates(item)}</Flex>
        <Flex flex=".5" > {item?.extraplates || 0}</Flex>
        <Flex flex="1.5">{platecost(item) || 0}</Flex>
        <Flex flex="1.5" textAlign='right'>{isNaN(parseFloat(platecost(item)) * getplates(item)) ? 0.00 : (parseFloat(platecost(item)) * getplates(item)).toFixed(2) || 0}</Flex> 
</Flexed>

</div>
</>
    })
}
</div>
    })
}


    </Collapse>
</div>
}          


  {   parseInt(item.press) > 6  && parseInt(item.press) < 11 && 
<div className="hand" style={{background:"#CFCDCC",marginBottom:"8px",border:"1px solid #c0c0c0",padding:"4px 0px",color:"black",marginTop:"10px"}} >
    <Collapse  margin="0" title={<Flexed alignItems="center" fontSize="calc(1.1rem + .2vw)">
          <Flex >Click Charge</Flex>
      
          <Flex flex="0" whiteSpace="nowrap">Cost: 0.00</Flex>
          <Flex flex="0" whiteSpace="nowrap">Total Cost: 0</Flex>
    </Flexed>} >
  


{
    info.options.map((form,index) => {
        console.log(form)
 return <div style={{padding:'8px 0px'}}> <Flexed>
    <Flex color='black' fontWeight='bold' fontSize='calc(1.2rem + .2vw)'>Option {index + 1}</Flex></Flexed> 
   <Flexed  fontSize="calc(1.1rem + .2vw)" fontWeight="bold" color='black'>
          <Flex >Form</Flex>
          <Flex >Needed</Flex>
        <Flex flex=".5" >Extra </Flex>
        <Flex flex="1.5"> Cost</Flex>
        <Flex flex="1.5" textAlign='right'> Total</Flex> 
</Flexed>


{
    form.forms?.map(item => {
        return  <><div style={{borderBottom:"1px solid grey",padding:'7px 0px'}}>
  <Flexed  color='black' fontSize="calc(1rem + .2vw)">
    <Flex >{item?.name}</Flex>
   <Flex  >{getplates(item)}</Flex>
        <Flex flex=".5" > {item?.extraplates || 0}</Flex>
        <Flex flex="1.5">{platecost(item) || 0}</Flex>
        <Flex flex="1.5" textAlign='right'>{isNaN(parseFloat(platecost(item)) * getplates(item)) ? 0.00 : (parseFloat(platecost(item)) * getplates(item)).toFixed(2) || 0}</Flex> 
</Flexed>

</div>
</>
    })
}
</div>
    })
}


    </Collapse>
</div>
}

    </>
  )
}

export default Form







